import { ReactNode, useContext, useEffect, useMemo } from 'react'
import styled from '@emotion/styled'
import { useFormSelector } from '../../../redux/formStoreHooks'
import { Theme } from '@emotion/react'
import L6FormContext, { L6FormContextValue } from '../l6/L6FormContext'
import { RenderMedia } from "@fusion-advantage/backcompat"

export const L4OnlyPrint = styled.div(({theme}) => ({
	display: theme.isPrintMode ? 'contents' : 'none',
}))

const L4NoPrintRoot = styled.div(({theme}) => ({
	display: theme.isPrintMode ? 'none' : 'contents',
}))

interface L4NoPrintProps {
	children: ReactNode
}

const noPrintSetXpathValuedDeterminer = () => {}

export const L4NoPrint = ({children}: L4NoPrintProps) => {
	const contextValue = useContext(L6FormContext)
	const newContextValue = useMemo((): L6FormContextValue => {
		return {
			...contextValue,
			setXpathValuedDeterminer: noPrintSetXpathValuedDeterminer,
		}
	}, [contextValue])
	return (
		<L6FormContext.Provider value={newContextValue}>
			<L4NoPrintRoot>
				{children}
			</L4NoPrintRoot>
		</L6FormContext.Provider>
	)
}

interface L4ShouldPrintProps {
	xpath: string
	children: ReactNode
}

export const L4ShouldPrint = ({xpath, children}: L4ShouldPrintProps) => {
	const { setXpathValuedDeterminer } = useContext(L6FormContext)
	useEffect(() => {
		if(xpath) {
			setXpathValuedDeterminer(xpath, true)
			return () => {
				setXpathValuedDeterminer(xpath, false)
			}
		}
	}, [xpath, setXpathValuedDeterminer ])
	return children
}

type L4PrintBoundRootProps = {
	shouldPrint: boolean
} & { theme: Theme }

const L4PrintBoundRoot = styled.div(({theme, shouldPrint}: L4PrintBoundRootProps) => ({
	display: (theme.isPrintMode && !shouldPrint) ? 'none' : 'contents', 
}))

interface L4PrintBoundProps {
	xpath: string
	children: ReactNode
}

export const L4PrintBound = ({xpath, children}: L4PrintBoundProps) => {
	const media = useFormSelector(state => state.render.media)
	if(media !== RenderMedia.Print) {
		return children
	}
	return <L4AutoPrintBound xpath={xpath}>{children}</L4AutoPrintBound>
}

// render for print if there's a value within the print bound
const L4AutoPrintBound = ({xpath, children}: L4PrintBoundProps) => {
	const { xpathsValued } = useContext(L6FormContext)
	return (
		<L4PrintBoundRoot shouldPrint={xpathsValued[xpath]}>
			{children}
		</L4PrintBoundRoot>
	)
}
